<app-page-header
  [iconType]="'Suggestion'"
  [text]="'Suggestion Box'"
></app-page-header>

<div class="sectionContainer paddedContent containerMargins">
  <app-feature-feedback-component>
    <p>
      We would love to hear your ideas for new features, changes to existing
      functionality, or any way we can improve this site.
    </p>
    <p>
      Be as specific as possible, and come back here any time you think of
      something!
    </p>
  </app-feature-feedback-component>
</div>
